// src/App.jsx
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import UserAuth from "./auth/userAuth";
import AdminAuth from "./auth/adminAuth";
import Chat from "./pages/Chat";
import GuestRegister from "./pages/GuestRegister";
import EventRegister from "./pages/EventRegister";
import RegisterEvent from "./pages/RegisterEvent";
import AdminEventSettings from "./pages/AdminEventSettings";
import AdminDashboard from "./pages/AdminDashboard";
import ThankYou from "./pages/ThankYou";
import Packages from "./pages/Packages";
import SpeakerModeWrapper from "./pages/SpeakerModeWrapper";
import GuestRoute from "./auth/GuestRoute";
import LicenseGuard from "./components/LicenseGuard";


import LandingPage from "./pages/LandingPage";
import DemoGuest from "./pages/DemoGuest";
import OrientationGuard from "./components/OrientationGuard";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Regulamin from "./pages/Regulamin";
import Contact from "./pages/Contact";

export default function App() {
  return (
    <Router>
      <OrientationGuard>
        <Routes>
          <Route path="/login" element={<UserAuth />} />

          <Route path="/demo-guest" element={<DemoGuest />} />
          <Route path="/" element={<LandingPage />} />

          <Route path="/admin" element={<AdminAuth />} />
          <Route path="/chat" element={<Chat />} />
          <Route
            path="/guestRegister/:secretId"
            element={<GuestRoute element={<GuestRegister />} />}
          />
          <Route path="/EventRegister" element={<EventRegister />} />
          <Route path="/admin-panel" element={<LicenseGuard><AdminDashboard /></LicenseGuard>} />
          <Route path="/RegisterEvent/:id" element={<RegisterEvent />} />
          <Route path="/AdminEventSettings" element={<LicenseGuard><AdminEventSettings /></LicenseGuard>} />
          <Route path="/packages" element={<Packages />} />
          <Route path="/speaker" element={<SpeakerModeWrapper />} />

          {/* ✅ NOWA TRASA PODZIĘKOWANIA */}
          <Route path="/thank-you" element={<ThankYou />} />

          {/* Legal pages */}
          <Route path="/polityka-prywatnosci" element={<PrivacyPolicy />} />
          <Route path="/regulamin" element={<Regulamin />} />

          {/* Kontakt */}
          <Route path="/kontakt" element={<Contact />} />

          {/* ♻️ Kompatybilność wstecz — przekierowanie na nową trasę */}
          <Route path="/dziekujemy" element={<Navigate to="/thank-you" replace />} />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </OrientationGuard>
    </Router>
  );
}
